import type { ComponentProps } from 'react';
import { cn } from '../lib/utils';

export function Card({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card" className={cn(className)} {...props} />;
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-header" className={cn(className)} {...props} />;
}

export function CardTitle({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-title" className={cn(className)} {...props} />;
}

export function CardDescription({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-description" className={cn(className)} {...props} />;
}

export function CardAction({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-action" className={cn(className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-content" className={cn(className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
   return <div data-slot="card-footer" className={cn(className)} {...props} />;
}
